import { render, staticRenderFns } from "./Committees.vue?vue&type=template&id=96c09982&scoped=true&"
import script from "./Committees.vue?vue&type=script&lang=js&"
export * from "./Committees.vue?vue&type=script&lang=js&"
import style0 from "./Committees.vue?vue&type=style&index=0&id=96c09982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c09982",
  null
  
)

export default component.exports